import { render, staticRenderFns } from "./PurchaseSubscription.vue?vue&type=template&id=fa374b28&scoped=true"
import script from "./PurchaseSubscription.vue?vue&type=script&lang=js"
export * from "./PurchaseSubscription.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSubscription.vue?vue&type=style&index=0&id=fa374b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa374b28",
  null
  
)

export default component.exports